if (!customElements.get("recently-viewed-products")) {

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.fetchData();
    }

    fetchData() {
      const arr = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
      if (!arr.length) {
        const parent = this.closest('.recently-viewed-products');
        parent.classList.add('d-none');
        parent.querySelector('recently-viewed-products__heading')?.remove();
        return;
      };

      fetch(`${location.href}?&section_id=pd-recently-viewed-product&product_handles=${arr.join(',')}`)
        .then(res => res.text())
        .then(res => {
          const html = new DOMParser().parseFromString(res, "text/html");
          const template = html.querySelector("template");
          const clone = template.content.cloneNode(true);
          this.innerHTML = clone.querySelector('.recently-viewed-products').innerHTML;
        })
        .then(() => {
          this.addMultipleEvents();
        })
    }

    addMultipleEvents() {
      this.querySelectorAll('[data-add-to-lists-button]')?.forEach(button => {

        button.addEventListener('click', e => {
          document.dispatchEvent(new CustomEvent('trigger::addToLists', {
            detail: {
              button
            }
          }));
        });
      })

      this.querySelectorAll('[data-add-to-registry]')?.forEach(button => {
        button.addEventListener('click', e => {
          document.dispatchEvent(new Event('trigger:AddToRegistry'));
        });
      })
    }

  }
  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}